/**
 * Split a `<Color-Picker>` `colors` attribute into CSS color tokens.
 * Commas inside parentheses (e.g. rgb(), rgba(), hsl()) do not start a new token.
 *
 * Must stay in sync with `engine/src/utils/splitColorPickerColorTokens.ts` so swatches
 * match backend allowlist checks.
 */
export function splitColorPickerColorTokens(colors: string): string[] {
  const parts: string[] = [];
  let buf = '';
  let depth = 0;
  for (let i = 0; i < colors.length; i++) {
    const c = colors[i];
    if (c === '(') {
      depth++;
    } else if (c === ')') {
      depth = Math.max(0, depth - 1);
    }
    if (c === ',' && depth === 0) {
      const t = buf.trim();
      if (t.length > 0) {
        parts.push(t);
      }
      buf = '';
    } else {
      buf += c;
    }
  }
  const t = buf.trim();
  if (t.length > 0) {
    parts.push(t);
  }
  return parts;
}
